import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, of, switchMap } from 'rxjs';
import { isApiRequest } from './api-request.guard';

/**
 * Attaches the OIDC access token as a `Bearer` Authorization header to backend
 * API requests. Identity-server traffic is skipped via {@link isApiRequest} so we
 * never re-enter the OIDC library's own token fetch.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  const oidcSecurityService = inject(OidcSecurityService);

  return oidcSecurityService.getAccessToken().pipe(
    // If the token can't be retrieved, proceed without it — the resulting 401
    // is handled downstream by errorMappingInterceptor.
    catchError(() => of('')),
    switchMap((token) =>
      next(
        token
          ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : req,
      ),
    ),
  );
};
